import type { ReactNode } from 'react';

export const symbol_airplay: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-260v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24.75-17.62 42.37Q844.75-200 820-200h-90q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h90v-520H140v520h89q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-89q-24.75 0-42.37-17.63Q80-235.25 80-260Zm248 141q-10.73 0-16.87-7-6.13-7-6.13-16 0-5 1.5-8.5t5.5-7.5l147-147q5-5 10.5-7t11-2q5.5 0 10.5 2t10 7l147 147q3.89 3.91 5.44 8.2 1.56 4.3 1.56 8.21 0 8.59-6 15.09t-17 7.5H328Zm152-371Z"
		/>
	</svg>
);
